import { render, staticRenderFns } from "./devicp.vue?vue&type=template&id=458af36a&scoped=true&"
import script from "./devicp.vue?vue&type=script&lang=js&"
export * from "./devicp.vue?vue&type=script&lang=js&"
import style0 from "./devicp.vue?vue&type=style&index=0&id=458af36a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458af36a",
  null
  
)

export default component.exports